import { ApplicationState } from '..';

export const getCourse = function getCourse(state:ApplicationState) {
    //console.log(state);
    return state.course.allIds.map(function (id:string) {
      return state.course.byId[id];
    });
};

export const getCourseByCourseId = function getCourseByCourseId(state:ApplicationState, courseId:string) {
  // console.log(courseId);
  var result = state.course.byId[courseId];
  return result;
};

export const getCourseByCategory = function getCourseByCategory(state:ApplicationState) {
    //console.log(state);
     const results:any[] =[];

    if (state.userReducer.ProfessionalCategory){
      state.userReducer.ProfessionalCategory.map(
          (professionalCategoty:string) =>{
            let _category ="";
            if(professionalCategoty === "Accountant")
              _category = "Accountancy";
            else if( professionalCategoty ==="Engineers")
              _category = "Engineering";
            else if( professionalCategoty ==="Contractors")
              _category = "Contractors";
      
            if( _category !=="" &&  state.course.byCategory[_category] !== undefined)
            {
              results.push({Category:_category, Courses:state.course.byCategory[_category].map(function (id:string) {
                  return state.course.byId[id];
                }) 
              });
            }
          }
        );
      }

      return results;

    // if(state.userReducer.ProfessionalCategory.length === 0){
    //   return state.course.Category.map(function (Category:any) {
    //     return {
    //       Category, 
    //       Courses:state.course.byCategory[Category].map(function (id:string) {
    //         return state.course.byId[id];
    //       })
    //     }
    //   });
    // }
    // else{
    //   if(state.course.Category.length ===0){
    //     return [];
    //   }
    //   else{

      
    //     const results:any[] =[];
    //      state.userReducer.ProfessionalCategory.map(
    //       (professionalCategoty:string) =>{
    //         let _category ="";
    //         if(professionalCategoty === "Accountant")
    //           _category = "Accountancy";
    //         else if( professionalCategoty ==="Engineers")
    //           _category = "Engineering";
    //         else if( professionalCategoty ==="Contractors")
    //           _category = "Contractors";
      
    //         if( _category !=="" &&  state.course.byCategory[_category] !== undefined)
    //         {
    //           results.push({Category:_category, Courses:state.course.byCategory[_category].map(function (id:string) {
    //               return state.course.byId[id];
    //             }) 
    //           });
    //         }
    //       }
    //     );

    //     return results;
    //   }
    // }
};


  export const getSelectedCourse = (state: ApplicationState) => state.course.byId[state.course.ui.selected];
